import { useMutation } from '@tanstack/react-query'

import { restartControllerForResource } from '@/features/resource/configuration/endpoints/resourceJsonConfiguration'

export function useRestartControllerForResourceMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation<void, Error, void>({
    mutationFn: () => restartControllerForResource(resourceId),
  })

  return {
    restartController: mutateAsync,
    ...mutationResult,
  }
}
